import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Globe2 } from 'lucide-react';
import { languages, useLanguage } from '../i18n';

export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const labels = { fr: 'Langue', en: 'Language', it: 'Lingua', es: 'Idioma' };
  return <label className="inline-flex min-h-11 items-center gap-2 rounded-full border border-indigo-100 bg-white px-3 text-sm text-indigo-950 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500">
    <Globe2 className="h-4 w-4 shrink-0" aria-hidden="true" />
    <span className="sr-only">{labels[language]}</span>
    <select aria-label={labels[language]} value={language} onChange={(event) => setLanguage(event.target.value)} className="min-h-11 max-w-full cursor-pointer bg-transparent pr-1 outline-none">
      {Object.entries(languages).map(([code, name]) => <option key={code} value={code} lang={code}>{name}</option>)}
    </select>
  </label>;
}

export function CustomerLanguageBar() {
  const { pathname } = useLocation();
  const { language } = useLanguage();
  const customer = /^\/(menu|cart|tip|order-confirmation|my-orders|entry|restaurant|table|scan)(\/|$)/.test(pathname);
  useEffect(() => {
    document.documentElement.lang = customer ? language : 'fr';
    document.documentElement.toggleAttribute('data-customer-page', customer);
    return () => document.documentElement.removeAttribute('data-customer-page');
  }, [customer, language]);
  return customer ? <div className="flex justify-end bg-slate-50 px-4 py-2"><LanguageSelector /></div> : null;
}
